import { render, staticRenderFns } from "./NonKomship.vue?vue&type=template&id=527c4938&"
import script from "./NonKomship.vue?vue&type=script&lang=js&"
export * from "./NonKomship.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports